export const makeApiUrl = (path: string): string => `${path}`
